<template>
  <i :class="collapseArrowClass()" @click="toggle" />
</template>

<script>
export default {
  props: {
    isOpen: Boolean,
    toggle: {
      type: Function,
      default: () => {},
    },
  },
  methods: {
    collapseArrowClass() {
      const arrowClass = `el-icon-arrow-${this.isOpen ? "down" : "right"}`;
      return { [arrowClass]: true, pointer: true };
    },
  },
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
</style>
